import React, { useState } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import { Link } from "react-scroll";

const NavBar = () => {
  const [nav, setNav] = useState(false);

  const links = [
    {
      id: 1,
      link: "home",
    },
    {
      id: 2,
      link: "about",
    },
    {
      id: 3,
      link: "portfolio",
    },
    {
      id: 4,
      link: "experience",
    },
    {
      id: 5,
      link: "contact",
    },
  ];

  return (
    <div
      className="flex justify-between items-center w-full h-20
    text-white bg-black px-4 fixed z-50"
    >
      <div>
        <h1 className="text-5xl font-signature">Manu</h1>
      </div>

      <ul className="hidden md:flex">
        {links.map(({ link, id }) => (
          <li
            key={id}
            className="px-4 capitalize hover:scale-105 
          duration-200 cursor-pointer font-medium text-gray-400"
          >
            <Link to={link} smooth duration={500}>
              {link}
            </Link>
          </li>
        ))}
      </ul>

      <div
        onClick={() => setNav(!nav)}
        className="pr-4 cursor-pointer text-gray-400 z-10 md:hidden"
      >
        {nav ? <FaTimes size={31} /> : <FaBars size={31} />}
      </div>

      {nav && (
        <ul
          className="flex flex-col justify-center items-center
                    absolute top-0 left-0 w-full h-screen 
                    bg-gradient-to-b from-black to-gray-800 text-gray-500"
        >
          {links.map(({ link, id }) => (
            <li
              key={id}
              className="text-4xl cursor-pointer py-6 px-4
                         capitalize"
            >
              <Link
                onClick={() => setNav(!nav)}
                to={link}
                smooth
                duration={500}
              >
                {link}
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default NavBar;
